import React from "react";
import { FeatureCollection, Geometry } from "geojson";
import BlossomTaskmap from "./wizard/BlossomTaskmap";
import VigourTaskmap from "./wizard/vigour/VigourTaskmap";
import { useLoaderData } from "react-router";
import { Geojson } from "./taskmap.types";

export type TaskmapProps = {
  geojson: Geojson;
  productKey: string;
};

const BLOSSOM_AREA_CM2 = "blossom_area_cm2";
const BLOSSOM_CLUSTER_COUNT = "blossom_cluster_count";
const VIGOUR_CLASS = "vigour_class";

const keys = [BLOSSOM_AREA_CM2, BLOSSOM_CLUSTER_COUNT, VIGOUR_CLASS];

function getTaskmapProperty(
  geojson: FeatureCollection<Geometry, object>,
): string {
  const properties = geojson.features[0].properties;
  for (const key of keys) {
    if (key in properties) {
      return key;
    }
  }
  return "";
}

export default function Taskmap(): React.ReactNode {
  const geojson = useLoaderData();
  const productKey = getTaskmapProperty(geojson);

  if (!productKey) return;

  if (productKey === BLOSSOM_AREA_CM2 || productKey === BLOSSOM_CLUSTER_COUNT) {
    return <BlossomTaskmap geojson={geojson} productKey={productKey} />;
  }
  return <VigourTaskmap geojson={geojson} productKey={productKey} />;
}
